module.exports = __webpack_public_path__ + "img/GALERIA-CIAZ-2021-3.bef50ba4.jpg";